import React from 'react';
import { reto5Data } from '../data/mock';
import { Timer, Dumbbell, CheckCircle2, Flame } from 'lucide-react';

export const Reto5 = () => {
  return (
    <section id="reto5" className="py-20 bg-black relative overflow-hidden">
      {/* subtle green glow */}
      <div className="absolute -top-24 left-1/2 -translate-x-1/2 w-[600px] h-[600px] bg-[#39FF14]/10 rounded-full blur-[120px] pointer-events-none" />

      <div className="container mx-auto px-4 relative z-10">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 bg-[#39FF14]/10 border border-[#39FF14]/40 text-[#39FF14] px-4 py-1.5 rounded-full text-sm font-bold mb-6">
            <Flame className="w-4 h-4" /> NOU ENTRENAMENT
          </div>
          <h2 className="text-5xl md:text-7xl font-black text-white mb-4 tracking-tight">
            RETO <span className="text-[#39FF14]">5</span>
          </h2>
          <p className="text-lg md:text-xl text-[#39FF14] font-bold uppercase tracking-wide mb-4">
            {reto5Data.subtitle}
          </p>
          <p className="text-base md:text-lg text-gray-400 max-w-2xl mx-auto">
            {reto5Data.description}
          </p>
        </div>

        {/* Exercises grid */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6 max-w-6xl mx-auto mb-14">
          {reto5Data.exercises.map((ex, i) => (
            <div
              key={i}
              data-testid={`reto5-exercise-${i}`}
              className="group bg-gradient-to-br from-gray-900 to-gray-800 border-2 border-gray-800 hover:border-[#39FF14] rounded-2xl p-5 flex flex-col transition-all duration-300 hover:-translate-y-1"
            >
              <div className="flex items-baseline gap-2 mb-2">
                <span className="text-4xl md:text-5xl font-black text-[#39FF14] leading-none group-hover:scale-105 origin-left transition-transform">
                  {ex.reps}
                </span>
              </div>
              <h3 className="text-white font-bold text-base md:text-lg leading-tight mb-2">{ex.name}</h3>
              {ex.detail && (
                <p className="text-gray-500 text-xs md:text-sm mt-auto pt-2 border-t border-gray-800/80 leading-snug">
                  {ex.detail}
                </p>
              )}
            </div>
          ))}
        </div>

        {/* Rules */}
        <div className="grid md:grid-cols-2 gap-6 max-w-5xl mx-auto">
          {/* Material */}
          <div className="bg-gradient-to-br from-gray-900 to-black border border-gray-800 rounded-2xl p-6 md:p-8">
            <div className="flex items-center gap-3 mb-5">
              <div className="w-11 h-11 rounded-xl bg-[#39FF14]/15 flex items-center justify-center">
                <Dumbbell className="w-6 h-6 text-[#39FF14]" />
              </div>
              <h3 className="text-xl md:text-2xl font-black text-white">Material</h3>
            </div>
            <ul className="space-y-3">
              {reto5Data.material.map((rule, i) => (
                <li key={i} className="flex items-start gap-3 text-gray-300 text-sm md:text-base">
                  <CheckCircle2 className="w-5 h-5 text-[#39FF14] flex-shrink-0 mt-0.5" />
                  <span>{rule}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* Time control */}
          <div className="bg-gradient-to-br from-gray-900 to-black border border-[#39FF14]/30 rounded-2xl p-6 md:p-8">
            <div className="flex items-center gap-3 mb-5">
              <div className="w-11 h-11 rounded-xl bg-[#39FF14]/15 flex items-center justify-center">
                <Timer className="w-6 h-6 text-[#39FF14]" />
              </div>
              <h3 className="text-xl md:text-2xl font-black text-white">Control del temps</h3>
            </div>
            <ul className="space-y-3">
              {reto5Data.timeControl.map((rule, i) => (
                <li key={i} className="flex items-start gap-3 text-gray-300 text-sm md:text-base">
                  <CheckCircle2 className="w-5 h-5 text-[#39FF14] flex-shrink-0 mt-0.5" />
                  <span>{rule}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};
